jQuery(document).ready(function () {
  if (!window.$cart) {
    console.warn('shareNoticeMail: $cart not ready');
    return;
  }

  /**
   * Generic handler for both shipping and payment notice buttons
   * @param {Event} e - Click event
   * @param {string} selector - The button selector (e.g. '#moreplast-shipping-methods-notice-button')
   */
  window.$cart.shareCartMailGeneric = function (e, selector) {
    if (e && e.preventDefault) e.preventDefault();

    var $btn = jQuery(selector);
    if (!$btn.length) return;

    window.$madUtil.blockElement($btn, { icon: { size: 'small' } });

    jQuery.ajax({
      type: 'POST',
      url: mad_cart_params.wc_ajax_url
        .toString()
        .replace('%%endpoint%%', 'mad_generate_share_cart_url'),
      data: { nonce: mad_cart_params.nonce },
      dataType: 'json'
    })
      .done(function (response) {
        window.$madUtil.unblockElement($btn);

        if (response.success && response.data.url) {
          var shareLink = response.data.url,
              // Different email subject/body depending on which button triggered the event
              subject =
                selector === '#moreplast-payment-methods-notice-button'
                  ? encodeURIComponent('Keine passende Zahlungsmethode')
                  : encodeURIComponent('Keine passende Versandmethode'),
              body = encodeURIComponent('Mein Warenkorb: ' + shareLink);

          var mail = $btn.data('mail') || 'info@moreplast-shop.de';

          window.location.href =
            'mailto:' + mail + '?subject=' + subject + '&body=' + body;
        } else {
          throw 'no-url';
        }
      })
      .fail(function () {
        window.$madUtil.unblockElement($btn);

        var mail = $btn.data('mail') || 'info@moreplast-shop.de',
            subject =
              selector === '#moreplast-payment-methods-notice-button'
                ? encodeURIComponent('Keine passende Zahlungsmethode')
                : encodeURIComponent('Keine passende Versandmethode');

        window.location.href =
          'mailto:' + mail + '?subject=' + subject;
      });
  };

  // Attach event listeners for both buttons
  jQuery(document.body).on(
    'click',
    '#moreplast-shipping-methods-notice-button',
    function (e) {
      window.$cart.shareCartMailGeneric(e, '#moreplast-shipping-methods-notice-button');
    }
  );

  jQuery(document.body).on(
    'click',
    '#moreplast-payment-methods-notice-button',
    function (e) {
      window.$cart.shareCartMailGeneric(e, '#moreplast-payment-methods-notice-button');
    }
  );
});
